import React from 'react'
import CSSModules from 'react-css-modules'

import SideNavIconButton from './SideNavIconButton'

const SideNavCommentIconButton = (props) => (
  <SideNavIconButton icon="comment" />
)

export default SideNavCommentIconButton
